import React, { useCallback, useContext } from 'react'
import { useDispatch } from 'react-redux'

import CarouselMediaFields from '../../../../../../ReusableFormFields/MediaFields/CarouselMediaFields'

import { transformCarouselToSingle } from './helpers'

import { AdFacebookEditContext } from '../../../AdFacebookEditContextProvider'

import { clearUpdateAd } from '../../../../../../../modules/actions/ads'

const CarouselMediaForm = ({ formik }) => {
  const dispatch = useDispatch()

  const { setValues } = formik

  const { campaignObjective } = useContext(AdFacebookEditContext)

  const switchAdToSingle = useCallback(
    carouselItems => {
      // transform formik modifiedAdValues to single values.
      // for that process carousel fields values are transformed to single item object
      const singleAdValues = transformCarouselToSingle(carouselItems)

      // set single items to formik
      setValues(singleAdValues)
    },
    [setValues]
  )

  const handleCarouselItemDelete = useCallback(
    carouselItems => {
      // switch Ad format from Carousel to Single when only one carousel item is left
      if (carouselItems.length === 1) {
        switchAdToSingle(carouselItems)
      }
      dispatch(clearUpdateAd())
    },
    [dispatch, switchAdToSingle]
  )

  return (
    <CarouselMediaFields
      formik={formik}
      onCarouselItemDelete={handleCarouselItemDelete}
      campaignObjective={campaignObjective}
    />
  )
}

export default CarouselMediaForm
